<div id="main">
  <!-- CONTENT -->
  <content></content>
  <!-- / CONTENT -->
</div>
